<template>
  <svg
    :viewBox="viewBox"
    class="icon"
    :class="[`fill-current ${color} is-${size}`]"
    v-bind="$attrs"
    role="img"
    :name="name"
    v-on="$listeners"
  >
    <defs v-if="filterId">
      <filter :id="filterId">
        <feDropShadow
          :dx="shadow.dx"
          :dy="shadow.dy"
          :stdDeviation="shadow.stdDeviation"
          :flood-opacity="shadow['flood-opacity']"
        />
      </filter>
    </defs>
    <!--    <title>{{ title || name }}</title>-->
    <!--    <desc v-if="desc">{{ desc }}</desc>-->

    <path
      v-if="filterId"
      :filter="`url(#${filterId})`"
      :d="getPath(name)"
    />
    <path
      v-else
      :d="getPath(name)"
    />

  </svg>
</template>

<script>
import icons from '@library/element/icon/icons.json'

export default {
  name: 'RenderIcon',
  props: {
    viewBox: {
      type: String,
      default: '0 0 24 24'
    },
    filterId: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    desc: {
      type: String,
      default: ''
    },
    shadow: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    getPath (name) {
      return icons[name]
    }
  }
}
</script>
